var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptrend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.71542C0 1.68661 0.863491 0.82312 4.8923 0.82312H9.84355C13.8724 0.82312 14.7358 1.68661 14.7358 5.71542V10.6667C14.7358 14.6955 13.8724 15.559 9.84355 15.559H4.8923C0.863491 15.559 0 14.6955 0 10.6667V5.71542Z",
    fill: "#5FBE91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68152 7.80732L7.36774 5.12109L10.054 7.80732M4.68152 10.8773L7.36774 8.19106L10.054 10.8773",
    stroke: "white",
    strokeWidth: 0.92099,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptrend);
export default __webpack_public_path__ + "static/media/uptrend.51455e0888b1e261f21931eff7188e2b.svg";
export { ForwardRef as ReactComponent };